module.exports = __webpack_public_path__ + "static/publiclab-dfa61ca3f2dae71d0503aeef7eac7f77.png";